import { FC } from 'react';
import { MenuIcon } from './MenuIcon';

type CollapsedItemProps = {
  icon: string;
  title: string;
  to?: string;
  isActive?: boolean;
};

const CollapsedItem: FC<CollapsedItemProps> = ({ icon, title, to, isActive = false }) => {
  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    if (to) {
      window.history.pushState({}, '', to);
      window.dispatchEvent(new PopStateEvent('popstate'));
    }
  };

  return (
    <a
      href={to || '#'}
      onClick={handleClick}
      className={`
        group flex items-center justify-center w-10 h-10 rounded-lg mx-auto
        transition-all duration-200 cursor-pointer
        ${isActive
          ? 'bg-emerald-500/20 text-emerald-400'
          : 'bg-white/[0.07] text-slate-300 hover:bg-white/[0.14] hover:text-white'
        }
      `}
      title={title}
    >
      <MenuIcon icon={icon} size={20} />
    </a>
  );
};

const menuItems = [
  { icon: '/media/icons/duotune/menu/home.svg', title: 'Pagina Inicial', to: '/home', isActive: true },
  { icon: '/media/icons/duotune/menu/unilever-white.svg', title: 'Unilever', to: '/cashback' },
  { icon: '/media/icons/duotune/menu/cashback.svg', title: 'Cashback', to: '/cashback' },
  { icon: '/media/icons/duotune/menu/conecta/conecta.svg', title: 'Conecta', to: '' },
  { icon: '/media/icons/duotune/menu/datatransfer/data-transfer.svg', title: 'Data Transfer', to: '' },
  { icon: '/media/icons/duotune/menu/reports/reports.svg', title: 'Relatorios', to: '' },
  { icon: '/media/icons/duotune/menu/api-manage-users.svg', title: 'API', to: '' },
  { icon: '/media/icons/duotune/menu/icon-logs.svg', title: 'Logs', to: '/logs' },
  { icon: '/media/icons/duotune/menu/robot-ai-svgrepo-com.svg', title: 'Compra AI', to: '/ai' },
  { icon: '/media/icons/duotune/menu/campaign.svg', title: 'Simulador de Campanhas', to: '/campaigns' },
  { icon: '/media/icons/duotune/menu/permissions.svg', title: 'Seller Mapping', to: '/seller-mapping' },
  { icon: '/media/icons/duotune/menu/infrapay.svg', title: 'Infrapay', to: '/infrapay' },
  { icon: '/media/icons/duotune/menu/devops-servers.svg', title: 'DevOps', to: '' },
  { icon: '/media/icons/duotune/menu/permissions2.svg', title: 'Permissoes', to: '/permissions' },
  { icon: '/media/icons/duotune/menu/settings.svg', title: 'Configuracoes', to: '/settings' },
];

const CollapsedMenu: FC = () => {
  return (
    <div className="flex flex-col gap-2 w-full px-2">
      {menuItems.map((item) => (
        <CollapsedItem
          key={item.title}
          icon={item.icon}
          title={item.title}
          to={item.to}
          isActive={item.isActive}
        />
      ))}
    </div>
  );
};

export { CollapsedMenu };
